"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
/* Package Imports */
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
/* Blast Imports */
require("./Dashboard.scss");
var Routes_1 = __importDefault(require("./Routes"));
var Navbar_1 = __importDefault(require("./components/navbar/Navbar"));
var Sidebar_1 = __importDefault(require("./components/sidebar/Sidebar"));
var actions_1 = require("./state/actions");
var GlobalIntervals_1 = __importDefault(require("@app/components/utils/GlobalIntervals"));
var TermsOfServiceModal_1 = require("@app/features/auth/components/TermsOfServiceModal");
var actions_2 = require("@app/features/pending-uploads/state/actions");
var AsperaDownloadModal_1 = __importDefault(require("@app/features/transfers/components/AsperaDownloadModal"));
var AsperaDownloadModal_2 = require("@app/features/transfers/components/AsperaDownloadModal");
var AsperaPlugin_1 = __importDefault(require("@app/features/transfers/components/AsperaPlugin"));
var AsperaVersionBanner_1 = require("@app/features/transfers/components/AsperaVersionBanner");
var LegacyBrowserModal_1 = __importDefault(require("@app/features/transfers/components/LegacyBrowserModal"));
var PluginlessTransferMonitor_1 = __importDefault(require("@app/features/transfers/components/PluginlessTransferMonitor"));
var actions_3 = require("@app/features/transfers/state/actions");
var selectors_1 = require("@app/features/transfers/state/selectors");
var actions_4 = require("@app/features/users/state/actions");
var config_1 = require("@app/shared/config");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var initialState = {
    asperaModalInitializing: false,
    asperaModalVisible: false,
    legacyBrowserModalVisible: false,
    termsOfServiceModalVisible: false
};
/**
 * The Blast Dashboard component, the container for each page found behind login
 */
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleCloseAsperaModal = function () {
            _this.props.onDismissAsperaModal();
            _this.setState(__assign(__assign({}, _this.state), { asperaModalVisible: false, legacyBrowserModalVisible: false }));
        };
        _this.handleCloseTermsModal = function () {
            _this.setState(__assign(__assign({}, _this.state), { termsOfServiceModalVisible: false }));
        };
        _this.handleDismissAsperaVersionBanner = function () {
            _this.props.onDismissAsperaVersionBanner();
        };
        _this.handleOpenTermsModal = function () {
            _this.setState(__assign(__assign({}, _this.state), { termsOfServiceModalVisible: true }));
        };
        _this.handleShowAsperaModal = function () {
            new matomo_1.MatomoTracker().trackEvent('User', 'Open Aspera Upgrade Modal');
            _this.setState(__assign(__assign({}, _this.state), { asperaModalVisible: true }));
        };
        _this.handleStartAspera = function () {
            if (react_device_detect_1.isSafari || _this.props.asperaEnabled) {
                /**
                 *  Specifically in Safari, the user must enable the Aspera extension and refresh the page for it to work
                 *  (Other browsers auto-refresh Blast upon extension installation from the browser's store)
                 *
                 *  Replacing previous actions with a window refresh which should act the same,
                 *  as long as all requirements for using Aspera Connect have been met
                 */
                window.location.reload(true);
            }
            else {
                _this.handleCloseAsperaModal();
                _this.props.onStartAspera();
            }
        };
        _this.handleStopAspera = function () {
            _this.props.onStopAspera();
        };
        _this.handleUseBlastLite = function () {
            if (!_this.props.asperaEnabled) {
                _this.props.onDismissAsperaInstall();
            }
            _this.handleCloseAsperaModal();
        };
        _this.stopModalInitializing = function () {
            _this.setState(__assign(__assign({}, _this.state), { asperaModalInitializing: false }));
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    Dashboard.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve(this.props.onRefreshPackageCache('latest'))];
                    case 1:
                        _a.sent();
                        this.props.onRefreshPackageCache('full');
                        this.props.onLoadUsers(this.props.isUserInternal);
                        this.props.onGetRemoteSources();
                        if (react_device_detect_1.isIE || react_device_detect_1.isLegacyEdge) {
                            this.setState(__assign(__assign({}, this.state), { legacyBrowserModalVisible: true }));
                            new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'View Modal');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Dashboard.prototype.componentDidUpdate = function (prevProps) {
        if (!this.props.asperaLoaded) {
            return;
        }
        if (prevProps.asperaEnabled !== this.props.asperaEnabled || prevProps.httpGatewayStatus !== this.props.httpGatewayStatus) {
            if (this.props.asperaEnabled) {
                log_1.default.info('Aspera enabled. Loading Connect transfers', 'Dashboard');
                this.props.onClearStagedFiles();
                this.props.onClearTransfers();
                this.props.onGetConnectTransfers();
                if (react_device_detect_1.isIE || react_device_detect_1.isLegacyEdge) {
                    this.setState(__assign(__assign({}, this.state), { legacyBrowserModalVisible: true }));
                    new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'View Modal');
                }
            }
            else {
                log_1.default.info('Aspera disabled. Loading pluginless transfers', 'Dashboard');
                this.props.onClearStagedFiles();
                this.props.onGetHttpTransfers();
            }
        }
        if (this.props.asperaInstallVisible && prevProps.asperaInstallVisible !== this.props.asperaInstallVisible) {
            if (!(react_device_detect_1.isIE || react_device_detect_1.isLegacyEdge)) {
                if (!this.props.asperaEnabled && !prevProps.asperaEnabled) {
                    this.setState(__assign(__assign({}, this.state), { asperaModalInitializing: this.props.asperaExtensionInstallStatus, asperaModalVisible: true }));
                    if (this.props.asperaExtensionInstallStatus) {
                        this.installModalSpinner = setTimeout(this.stopModalInitializing, 5000);
                    }
                }
            }
            else {
                this.setState(__assign(__assign({}, this.state), { legacyBrowserModalVisible: true }));
                new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'View Modal');
            }
        }
    };
    /* Component Methods - End */
    Dashboard.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AsperaPlugin_1.default, null),
            react_1.default.createElement(AsperaVersionBanner_1.AsperaVersionBanner, { isVisible: this.props.asperaVersionBannerVisible, onDismiss: this.handleDismissAsperaVersionBanner, onDisplayModal: this.handleShowAsperaModal }),
            react_1.default.createElement(Navbar_1.default, null),
            react_1.default.createElement("div", { className: "columns dash is-gapless" },
                react_1.default.createElement("div", { className: "column left is-2" },
                    react_1.default.createElement(Sidebar_1.default, { pageSize: config_1.Config.DEFAULT_PAGE_SIZE, asperaVersion: this.props.asperaVersion, openTermsModal: this.handleOpenTermsModal })),
                react_1.default.createElement("div", { className: "column right is-10" },
                    react_1.default.createElement(Routes_1.default, { match: this.props.match.url }))),
            this.state.asperaModalVisible &&
                react_1.default.createElement(AsperaDownloadModal_1.default, { extInstallStatus: this.props.asperaExtensionInstallStatus, extInstallUrl: this.props.asperaExtensionInstallUrl, isInitializing: this.state.asperaModalInitializing, onClose: this.handleCloseAsperaModal, onContinue: this.handleStartAspera, onStopAspera: this.handleStopAspera, onUseBlastLite: this.handleUseBlastLite }),
            this.state.asperaModalVisible && react_device_detect_1.isEdge &&
                react_1.default.createElement(AsperaDownloadModal_2.EdgeAsperaPluginNotification, null),
            this.state.legacyBrowserModalVisible &&
                react_1.default.createElement(LegacyBrowserModal_1.default, { isPreLogin: false, onClose: this.handleCloseAsperaModal, onStopAspera: this.handleStopAspera, onUseBlastLite: this.handleUseBlastLite }),
            this.state.termsOfServiceModalVisible &&
                react_1.default.createElement(TermsOfServiceModal_1.TermsOfServiceModal, { closeOnEscape: true, hideButtons: true, onClose: this.handleCloseTermsModal }),
            react_1.default.createElement(PluginlessTransferMonitor_1.default, null),
            react_1.default.createElement(GlobalIntervals_1.default, null)));
    };
    return Dashboard;
}(react_1.Component));
exports.Dashboard = Dashboard;
var mapStateToProps = function (state) {
    return {
        asperaEnabled: selectors_1.isAsperaEnabled(state),
        asperaExtensionInstallStatus: state.transfers.extensionInstallStatus,
        asperaExtensionInstallUrl: state.transfers.extensionInstallUrl,
        asperaInstallVisible: state.transfers.asperaInstallVisible,
        asperaLoaded: selectors_1.isAsperaLoaded(state),
        asperaVersion: state.transfers.connectVersion,
        asperaVersionBannerVisible: state.transfers.asperaVersionBannerVisible,
        httpGatewayStatus: state.transfers.httpGatewayStatus,
        isUserInternal: state.auth.userInfo ? state.auth.userInfo.isInternal : false
    };
};
var mapDispatchToProps = {
    onClearStagedFiles: actions_3.clearStagedFiles,
    onClearTransfers: actions_2.clearPendingTransfers,
    onDismissAsperaInstall: actions_3.dismissAsperaInstall,
    onDismissAsperaModal: actions_3.hideAsperaInstall,
    onDismissAsperaVersionBanner: actions_3.dismissAsperaVersionBanner,
    onGetConnectTransfers: actions_3.getAllConnectTransfers,
    onGetHttpTransfers: actions_2.refreshPendingTransfers,
    onGetRemoteSources: actions_4.getRemoteSources,
    onLoadUsers: actions_4.loadUsers,
    onRefreshPackageCache: actions_1.refreshPackageCache,
    onStartAspera: actions_3.startAspera,
    onStopAspera: actions_3.stopAspera
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Dashboard);
